<div class="cashier-method__form">
    <div class="form-group">
        <div class="payment-input controls field-invalid">
            <input class="floatLabel form-control" type="text" (focus)="onFocusForElement('Full name')" (focusout)="onFocusOutForElement()">
            <label for="Full name" >{{'customCashier.creditCard.fullName' | translate}}</label>
           <app-custom-error-message  [message]="errorMessage"></app-custom-error-message>
        </div>
    </div>
    <div class="form-group">
        <div class="payment-input icn-input icn-card-num controls field-valid">
            <input class="floatLabel form-control" type="text" (focus)="onFocusForElement('Credit card number')" (focusout)="onFocusOutForElement()">
            <label for="Card number" >{{'customCashier.creditCard.creditCardNumber' | translate}}</label>
        </div>
    </div>
    <div class="form-group multi-field-row">
        <div class="payment-input icn-input icn-card-num controls">
            <input class="floatLabel form-control" type="text" (focus)="onFocusForElement('Expiry MM/YY')" (focusout)="onFocusOutForElement()">
            <label for="Card number" >{{'customCashier.creditCard.expiryLabel' | translate}}</label>
        </div>
        <div class="payment-input icn-input icn-card-cvv controls">
            <input class="floatLabel form-control" type="text" (focus)="onFocusForElement('icn-card-cvv')" (focusout)="onFocusOutForElement()">
            <label for="Card number" >{{'customCashier.creditCard.cvvLabel' | translate}}</label>
        </div>
    </div>
</div>
